import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import geographyData from "./geography.json";

const inputCls = "w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors";
const labelCls = "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5";
const selectCls = "w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors appearance-none";

function EditProfile() {
  const getToken = () => Cookies.get("jwt");

  const [profileUpdate, setprofileUpdate] = useState("");
  const [profileInit, setProfileInit] = useState(null);
  const [dataUpdate, setDataUpdate] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    age: 18,
    zipcode: "",
    facebook: null,
    lineId: null,
  });
  const [dataBeforeUpdate, setDataBeforeUpdate] = useState({
    age: "",
    email_address: "",
    facebook: "",
    first_name: "",
    gender: "",
    last_name: "",
    line_id: "",
    phone_number: "",
    profile_image: "",
  });
  const [dataLocationUpdate, setDataLocationUpdate] = useState({
    province: "",
    amphure: "",
    tambol: "",
    zipcode: "",
  });

  const [provinceData, setProvinceData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [subdistrictData, setSubdistrictData] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedSubdistrict, setSelectedSubdistrict] = useState("");
  const [genderSelected, setGenderSelected] = useState("");

  const handleProvinceChange = (e) => {
    const provinceName = e.target.value;
    setSelectedProvince(provinceName);
    setSelectedDistrict("");
    setSelectedSubdistrict("");
    setDataLocationUpdate((prev) => ({ ...prev, province: provinceName }));
    const districts = Array.from(new Set(
      geographyData.filter((i) => i.provinceNameTh === provinceName).map((i) => i.districtNameTh)
    ));
    setDistrictData(districts);
    setSubdistrictData([]);
  };

  const handleDistrictChange = (e) => {
    const districtName = e.target.value;
    setSelectedDistrict(districtName);
    setSelectedSubdistrict("");
    setDataLocationUpdate((prev) => ({ ...prev, amphure: districtName }));
    const subdistricts = Array.from(new Set(
      geographyData
        .filter((i) => i.districtNameTh === districtName && i.provinceNameTh === selectedProvince)
        .map((i) => i.subdistrictNameTh)
    ));
    setSubdistrictData(subdistricts);
  };

  const handleSubdistrictChange = (e) => {
    const subdistrictName = e.target.value;
    setSelectedSubdistrict(subdistrictName);
    setDataLocationUpdate((prev) => ({ ...prev, tambol: subdistrictName }));
    const postalCode = geographyData.find(
      (i) => i.subdistrictNameTh === subdistrictName && i.districtNameTh === selectedDistrict && i.provinceNameTh === selectedProvince
    )?.postalCode;
    setDataUpdate((prev) => ({ ...prev, zipcode: postalCode || "" }));
    setDataLocationUpdate((prev) => ({ ...prev, zipcode: postalCode || "" }));
  };

  const handleUsernameChange = async () => {
    await Swal.fire({
      title: "กรุณากรอก username ใหม่ที่ต้องการ",
      input: "text",
      inputPlaceholder: "กรอกชื่อผู้ใช้ใหม่ของคุณ",
      showCancelButton: true,
      confirmButtonText: "บันทึก",
      cancelButtonText: "ยกเลิก",
      inputValidator: (value) => (!value ? "คุณต้องกรอก username ใหม่!" : null),
    });
  };

  const handleFileUpload = async (event) => {
    const ImageUpload = event.target.files[0];
    const formData = new FormData();
    formData.append("image", ImageUpload);
    try {
      await axios.put(`${process.env.REACT_APP_API}/update/profile-image`, formData, {
        headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
      });
      setProfileInit(ImageUpload);
      Swal.fire("สำเร็จ!", "เปลี่ยนรูปโปรไฟล์สำเร็จ", "success");
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API}/user/getDataProfile`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        const { age, email_address, facebook, first_name, gender, last_name, line_id, phone_number, profile_image, zipcode, province, amphure, tambol } = res.data;

        setDataBeforeUpdate({ age, email_address, facebook, first_name, gender, last_name, line_id, phone_number, profile_image });
        setDataUpdate({ first_name, last_name, gender, age, facebook, lineId: line_id, zipcode });
        setprofileUpdate(profile_image);
        setGenderSelected(gender);
        setDataLocationUpdate({ province, amphure, tambol, zipcode });

        const uniqueProvinces = Array.from(new Set(geographyData.map((i) => i.provinceNameTh)));
        setProvinceData(uniqueProvinces);
        // โปรไฟล์ที่ยังไม่เคยกรอกที่อยู่ API จะคืน null มา ถ้าใส่ตรง ๆ <select value={null}>
        // React จะเตือนว่า value ไม่ควรเป็น null และช่องจะกลายเป็น uncontrolled
        setSelectedProvince(province ?? "");
        setSelectedDistrict(amphure ?? "");
        setSelectedSubdistrict(tambol ?? "");

        setDistrictData(Array.from(new Set(
          geographyData.filter((i) => i.provinceNameTh === province).map((i) => i.districtNameTh)
        )));
        setSubdistrictData(Array.from(new Set(
          geographyData.filter((i) => i.districtNameTh === amphure && i.provinceNameTh === province).map((i) => i.subdistrictNameTh)
        )));
      } catch (err) {
        console.error(err);
      }
    };
    fetchProfileData();
  }, []);

  const inputValue = (name) => (e) => setDataUpdate({ ...dataUpdate, [name]: e.target.value });

  const genderHandle = (gender) => {
    setGenderSelected(gender);
    setDataUpdate({ ...dataUpdate, gender });
  };

  const updateGeneralData = () =>
    axios.put(
      `${process.env.REACT_APP_API}/update/profile-data`,
      { age: dataUpdate.age, firstName: dataUpdate.first_name, lastName: dataUpdate.last_name, bio: "test", email: "", gender: dataUpdate.gender, lineId: dataUpdate.lineId, facebookUrl: dataUpdate.facebook },
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );

  const updateLocatoinData = () =>
    axios.put(`${process.env.REACT_APP_API}/update/profile-location`, dataLocationUpdate, {
      headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" },
    });

  const updateProfile = async (e) => {
    e.preventDefault();
    try {
      await Promise.all([updateGeneralData(), updateLocatoinData()]);
      await Swal.fire("อัพเดทข้อมูลเรียบร้อย!", "กำลังพาคุณไปหน้าโปรไฟล์..", "success");
      window.location.replace("/profiles");
    } catch (err) {
      Swal.fire("เกิดข้อผิดพลาด!", `${err?.response?.data?.Error || "กรุณาลองใหม่"}`, "error");
    }
  };

  const avatarSrc = profileInit
    ? URL.createObjectURL(profileInit)
    : profileUpdate || "https://cdn-icons-png.flaticon.com/512/9460/9460908.png";

  const genderOptions = [
    { key: "male", label: "ชาย" },
    { key: "female", label: "หญิง" },
    { key: "lgbt", label: "ไม่ระบุ / LGBTQ+" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 font-['Prompt']">
      {getToken() !== undefined ? (
        <div className="max-w-2xl mx-auto px-4 py-8 space-y-4">

          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="flex items-center gap-3"
          >
            <Link
              to="/profiles"
              className="w-9 h-9 bg-white rounded-xl flex items-center justify-center border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors flex-shrink-0"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </Link>
            <div>
              <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">PostPerty</p>
              <h1 className="text-lg font-bold text-gray-900">แก้ไขโปรไฟล์</h1>
            </div>
          </motion.div>

          <form onSubmit={updateProfile} className="space-y-4">

            {/* Avatar */}
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.04 }}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex flex-col items-center gap-3"
            >
              <div className="relative">
                <img
                  src={avatarSrc}
                  alt="Profile"
                  className="w-20 h-20 rounded-full object-cover ring-4 ring-gray-100"
                />
                <input
                  type="file"
                  accept="image/*"
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                  onChange={handleFileUpload}
                />
                <div className="absolute -bottom-1 -right-1 w-7 h-7 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 z-20">
                  <img src="https://cdn-icons-png.flaticon.com/512/44/44413.png" alt="edit" className="w-3.5 h-3.5" />
                </div>
              </div>
              <p className="text-xs text-gray-400">แตะที่รูปเพื่อเปลี่ยนรูปโปรไฟล์</p>
            </motion.div>

            {/* ข้อมูลส่วนตัว */}
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.08 }}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 space-y-4"
            >
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">ข้อมูลส่วนตัว</p>

              <div>
                <label className={labelCls}>ชื่อ <span className="normal-case font-normal text-gray-400">(ไม่จำเป็น)</span></label>
                <input
                  type="text"
                  placeholder="ชื่อ"
                  defaultValue={dataBeforeUpdate.first_name}
                  onChange={inputValue("first_name")}
                  className={inputCls}
                />
              </div>

              <div>
                <label className={labelCls}>นามสกุล <span className="normal-case font-normal text-gray-400">(ไม่จำเป็น)</span></label>
                <input
                  type="text"
                  placeholder="นามสกุล"
                  defaultValue={dataBeforeUpdate.last_name}
                  onChange={inputValue("last_name")}
                  className={inputCls}
                />
              </div>

              <div>
                <label className={labelCls}>เพศ</label>
                <div className="grid grid-cols-3 gap-2">
                  {genderOptions.map(({ key, label }) => (
                    <button
                      key={key}
                      type="button"
                      onClick={() => genderHandle(key)}
                      className={`py-2.5 text-sm font-semibold rounded-xl transition-colors ${
                        genderSelected === key
                          ? "bg-blue-600 text-white"
                          : "bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100"
                      }`}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label className={labelCls}>อายุ <span className="normal-case font-normal text-gray-400">(ขั้นต่ำ 18 ปี)</span></label>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => setDataUpdate((p) => ({ ...p, age: Math.max(Number(p.age) - 1, 18) }))}
                    className="w-11 h-11 bg-gray-100 rounded-xl text-lg font-bold text-gray-600 hover:bg-gray-200 transition-colors flex-shrink-0"
                  >
                    −
                  </button>
                  <input
                    type="number"
                    value={dataUpdate.age}
                    onChange={(e) => setDataUpdate((p) => ({ ...p, age: Math.max(18, Math.min(90, parseInt(e.target.value) || 18)) }))}
                    className={`${inputCls} text-center`}
                    min="18"
                    max="90"
                  />
                  <button
                    type="button"
                    onClick={() => setDataUpdate((p) => ({ ...p, age: Math.min(Number(p.age) + 1, 90) }))}
                    className="w-11 h-11 bg-gray-100 rounded-xl text-lg font-bold text-gray-600 hover:bg-gray-200 transition-colors flex-shrink-0"
                  >
                    +
                  </button>
                </div>
              </div>

              <div>
                <label className={labelCls}>Username</label>
                <button
                  type="button"
                  onClick={handleUsernameChange}
                  className="w-full py-3 bg-gray-50 border border-gray-200 text-gray-700 text-sm font-semibold rounded-xl hover:bg-gray-100 transition-colors"
                >
                  เปลี่ยนชื่อผู้ใช้
                </button>
              </div>
            </motion.div>

            {/* ที่อยู่ */}
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.12 }}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 space-y-4"
            >
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">ที่อยู่</p>

              <div>
                <label className={labelCls}>จังหวัด</label>
                <select value={selectedProvince} onChange={handleProvinceChange} className={selectCls}>
                  <option value="">เลือกจังหวัด</option>
                  {provinceData.map((p) => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>

              <div>
                <label className={labelCls}>อำเภอ / เขต</label>
                <select value={selectedDistrict} onChange={handleDistrictChange} className={selectCls} disabled={!selectedProvince}>
                  <option value="">เลือกอำเภอ / เขต</option>
                  {districtData.map((d) => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>

              <div>
                <label className={labelCls}>ตำบล / แขวง</label>
                <select value={selectedSubdistrict} onChange={handleSubdistrictChange} className={selectCls} disabled={!selectedDistrict}>
                  <option value="">เลือกตำบล / แขวง</option>
                  {subdistrictData.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>

              <div>
                <label className={labelCls}>รหัสไปรษณีย์</label>
                <input
                  type="text"
                  value={dataUpdate.zipcode || ""}
                  readOnly
                  className={`${inputCls} text-gray-400 cursor-default`}
                  placeholder="กรอกอัตโนมัติ"
                />
              </div>
            </motion.div>

            {/* โซเชียลมีเดีย */}
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.16 }}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 space-y-4"
            >
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">โซเชียลมีเดีย</p>

              <div>
                <label className={labelCls}>Facebook</label>
                <input
                  type="text"
                  defaultValue={dataBeforeUpdate.facebook}
                  onChange={inputValue("facebook")}
                  placeholder="ลิงก์ Facebook"
                  className={inputCls}
                />
              </div>

              <div>
                <label className={labelCls}>Line ID</label>
                <input
                  type="text"
                  defaultValue={dataBeforeUpdate.line_id}
                  onChange={inputValue("lineId")}
                  placeholder="Line ID ของคุณ"
                  className={inputCls}
                />
              </div>
            </motion.div>

            {/* Submit */}
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.2 }}
            >
              <button
                type="submit"
                className="w-full py-3.5 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors"
              >
                ยืนยันการแก้ไข
              </button>
            </motion.div>

            <div className="h-8" />
          </form>
        </div>
      ) : (
        <div>{window.location.replace("/login")}</div>
      )}
    </div>
  );
}

export default EditProfile;
